var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"anno-altsidebar"},[_c('b-field',{attrs:{"label":"Label Type"}},[_c('label-type-selector')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }